import FullscreenLoading from "./fullscreen-loading";

export default FullscreenLoading;